import {
  ALL_COMMERCIAL_DATA,
  ALL_DEALS_DATA,
  ALL_EVENTS_DAT,
  ALL_EVENTS_DATA,
  ALL_NEAR_COMMERCIAL,
  ALL_PLACES_DATA,
  ALL_POPULAR_COMMERCIAL,
  ALL_USER_COMMERCIAL_DATA,
  COMMERCIAL_DETAILS,
  LANGUAGE,
  LOGIN,
  PLACE_DETAILS,
  USER, PLACE_STATES,
  SAVED_ITEMS
} from "../types";

const initialValue = {
  user: {},
  placeDetails: {},
  commercialDetails: [],
  allPlacesData: [],
  allDealsData: [],
  ALLEventsData: [],
  allCommercialData: [],
  allUserCommercialData: [],
  allPopularCommercialData: [],
  allNearCommercialData: [],
  language: {},
  placeStats: {},
  allSavedItems:[]
};

const reducerData = (state = initialValue, action) => {
  switch (action.type) {
    case LOGIN: {
      return {
        ...state,
        user: action.payload,
      };
    }
    case USER: {
      return {
        ...state,
        user: action.payload,
      };
    }
    case PLACE_DETAILS: {
      return {
        ...state,
        placeDetails: action.payload,
      };
    }
    case COMMERCIAL_DETAILS: {
      return {
        ...state,
        commercialDetails: action.payload,
      };
    }
    case ALL_PLACES_DATA: {
      return {
        ...state,
        allPlacesData: action.payload,
      };
    }
    case PLACE_STATES: {
      return {
        ...state,
        placeStats: action.payload,
      };
    }
    case ALL_DEALS_DATA: {
      return {
        ...state,
        allDealsData: action.payload,
      };
    }
    case ALL_EVENTS_DATA: {
      return {
        ...state,
        ALLEventsData: action.payload,
      };
    }
    case ALL_COMMERCIAL_DATA: {
      return {
        ...state,
        allCommercialData: action.payload,
      };
    }

    case ALL_USER_COMMERCIAL_DATA: {
      return {
        ...state,
        allUserCommercialData: action.payload,
      };
    }
    case ALL_POPULAR_COMMERCIAL: {
      return {
        ...state,
        allPopularCommercialData: action.payload,
      };
    }

    case ALL_NEAR_COMMERCIAL: {
      return {
        ...state,
        allNearCommercialData: action.payload,
      };
    }

    case LANGUAGE: {
      return {
        ...state,
        language: action.payload,
      };
    }
    case SAVED_ITEMS:{
      return {...state,allSavedItems:action.payload}
    }

    default:
      return state;
  }
};

export default reducerData;
